import { cn } from '@/lib/utils'

interface PassRateBarProps {
  passRate: number // 0 to 1
  size?: 'sm' | 'md' | 'lg'
  showLabel?: boolean
}

/**
 * Visual bar showing pass rate percentage
 */
export function PassRateBar({ passRate, size = 'md', showLabel = true }: PassRateBarProps) {
  const percentage = Math.round(passRate * 100)

  // Color based on pass rate
  const getBarColor = () => {
    if (passRate >= 0.8) return 'bg-success-500'
    if (passRate >= 0.6) return 'bg-warning-500'
    return 'bg-error-500'
  }

  const sizeClasses = {
    sm: 'h-1.5',
    md: 'h-2',
    lg: 'h-3',
  }

  return (
    <div className="flex items-center gap-2">
      <div
        className={cn(
          'flex-1 overflow-hidden rounded-full bg-gray-200 dark:bg-gray-700',
          sizeClasses[size]
        )}
      >
        <div
          className={cn('h-full transition-all duration-300', getBarColor())}
          style={{ width: `${percentage}%` }}
        />
      </div>
      {showLabel && (
        <span
          className={cn(
            'min-w-[3rem] text-right font-medium',
            size === 'lg' ? 'text-lg' : 'text-sm',
            passRate >= 0.8
              ? 'text-success-600 dark:text-success-400'
              : passRate >= 0.6
                ? 'text-warning-600 dark:text-warning-400'
                : 'text-error-600 dark:text-error-400'
          )}
        >
          {percentage}%
        </span>
      )}
    </div>
  )
}

export default PassRateBar
